<template>
    <div class="QualityTest" ref="Box">
        <div class="QualityTestHeader">
            <img src="../../assets/img/left.png" @click="$router.back()" />
            巡检实施
        </div>
        <div class="infoBox quality">
            <div class="tableTitle">
                <div>项目内容</div>
                <div>巡检结果</div>
            </div>
            <div class="tableItems">
                <div class="tableItemsRightBox">
                    <div v-for="item in list">
                        <div>{{item.MC}}</div>
                        <div>
                            <div @click="item.JCJG=item.BZ.split('/')[0]" :class="item.JCJG.trim()!==item.BZ.split('/')[1]?'action':''">{{item.BZ.split('/')[0]}}</div>

                            <div @click="item.JCJG=item.BZ.split('/')[1]" :class="item.JCJG.trim()===item.BZ.split('/')[1]?'action':'' ">{{item.BZ.split('/')[1]}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div @click="AddErrorContent=true">
            <span>异常情况</span>
            <span>新增</span>
        </div>

        <div v-if="ErrorResult.length!==0">
            <div class="AccessoriesItemBox" v-for="(item,index) in ErrorResult">
                <van-swipe-cell>
                    <van-cell title="资产名称" :value="`${item.SBMC}(${item.SBBH})`"/>
                    <van-cell title="异常情况" :value="item.YCQK"/>
                    <van-cell title="处理意见" :value="item.CLYJ"/>
                    <template #right>
                        <div class="delete" @click="_deleteErrorContent(index)">
                            <img src="../../assets/img/delete.png"/>
                        </div>
                    </template>
                </van-swipe-cell>
            </div>
        </div>

        <div class="infoBox quality">
            <div class="tableItems" v-for="item in list2">
                <div class="tableItemsLeftBox">{{item.title}}</div>
                <div :class="'tableItemsRightBox2 ' + item.type">
                    <van-checkbox-group v-model="calibration" v-if="item.type === 'checkbox-group'">
                        <van-checkbox v-for="(itemList,index) in item.list" :key="index" :name="index" checked-color="#4fa69e">{{itemList}}</van-checkbox>
                    </van-checkbox-group>
                    <van-radio-group v-model="actuality" v-if="item.type === 'checkbox'">
                        <van-radio v-for="(itemList, index) in item.list" :key="index" :name="index" checked-color="#4fa69e">{{itemList}}</van-radio>
                    </van-radio-group>
                    <div class="input-group" v-if="item.type === 'input-group'">
                        <div v-for="itemList in item.list">
                            <p>{{itemList.text}}</p>
                            <input type="text" v-if="itemList.type !== 'calender'" placeholder="请输入" v-model="itemList.explain"
                                :disabled="itemList.disabled ? 'disabled' : false" />

                            <div class="calenderText" v-if="itemList.type === 'calender'" @click="(showCalendar = true,setData = itemList)">{{itemList.explain ? itemList.explain : "请输入"}}</div>
                            <van-calendar :round="false" v-if="itemList.type === 'calender'" v-model="showCalendar"
                                @confirm="onConfirm" />
                        </div>
                    </div>
                    <input v-if="item.type === 'input'" type="text" :placeholder="item.explain ? item.explain : '请输入'"
                        v-model="item.explain" />
                </div>
            </div>
        </div>
        <div class="imgBox">
            <ImgModule :deletable='!this.$route.params.ButtonExists' :disabled="this.$route.params.ButtonExists" upload
                :img="uploadImg" title="图片" @afterRead="afterRead(arguments[0])" @deleteImg="deleteImg(arguments[0])" />
        </div>
        <div v-if="!this.$route.params.ButtonExists" class="footer" @click="upload">提交</div>
        <div class="marginTop"></div>
        <transition name="fade">
            <div class="ErrorContent">
                <van-popup v-model="AddErrorContent" @close="ErrorData={SBMC:'请选择'}" closeable round position="bottom" :style="{width:'100%',height:'100%'}">
                    <div style="margin-top: 30px;">
                        <van-cell>
                            <template>
                                <div class="EquipmentContent" @click="EquipmentContentClick">
                                    <span>资产名称</span>
                                    <div :class="ErrorData.SBMC=='请选择'?'emptyContent':''">
                                        {{ErrorData.SBMC}}
                                        <img src="../../assets/img/right.png" />
                                    </div>
                                </div>
                            </template>
                        </van-cell>
                        <van-cell>
                            <template>
                                <div>
                                    <van-field label="异常情况" label-class='labelclass' type='textarea' :clickable='true' v-model="ErrorData.YCQK" :show-word-limit='true' maxlength='200' placeholder="最多200字符"
                                        input-align="right" clearable />
                                </div>
                            </template>
                        </van-cell>
                        <van-cell>
                            <template>
                                <div>
                                    <van-field label="处理意见" label-class='labelclass' type='textarea' :clickable='true' v-model="ErrorData.CLYJ" :show-word-limit='true' maxlength='200' placeholder="最多200字符"
                                        input-align="right" clearable />
                                </div>
                            </template>
                        </van-cell>
                    </div>
                    <div class="ErrorButton" @click="ErrorButtonClick">
                        <span>确定</span>
                    </div>
                </van-popup>
            </div>
        </transition>

        <van-popup v-model="showDiaLog" position="top" :style="{ height: '100%', borderRadius: '10px 10px 0 0'}">
            <div class="picker-header">
                <span @click="showDiaLog=false">取消</span>
                <input type="text" placeholder="输入" @input="_manupopupInput" />
                <span @click="manuconfirm">确定</span>
            </div>
            <van-picker :columns="manudata" @cancel="showPicker = false" @change="manuonChange"
                item-height="10vw" swipe-duration="500" :default-index="manuselectIndex" />
        </van-popup>
    </div>

</template>

<script>
    import ImgModule from '../../components/imgModule/imgModule'
    import {
        SwipeCell,
        Field,
        picker,
        popup,
        cell,
        CheckboxGroup,
        Checkbox,
        RadioGroup,
        Radio,
        Calendar
    } from 'vant'
    export default {
        name: 'PollingimplementDefault_XS',
        data() {
            return {
                outTime: 0, //定时器
                ErrorData: {
                    SBMC: '请选择'
                },
                ErrorResult:[],
                manuselectIndex: 0, //默认选中索引
                manudata: [], //下拉数据集
                showDiaLog: false,
                uploadImg: [],
                showCalendar: false,
                AddErrorContent: false,
                data: this.$route.params.item, //基础数据
                list: [], //模板内容  api获取
                list2: [{
                    title: '其它',
                    list: [{
                        text: '巡检人',
                        explain: this.$UserInfo.UserId,
                    }, {
                        text: '巡检日期',
                        explain: this.$format(new Date(), 'YYYY-MM-DD'),
                    }],
                    type: 'input-group'
                }, ],
                NowDate: this.$format(new Date(), 'YYYY-MM-DD'),
            }
        },
        components: {
            ImgModule,
            [Calendar.name]: Calendar,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [popup.name]: popup,
            [cell.name]: cell,
            [picker.name]: picker,
            [Field.name]: Field,
            [SwipeCell.name]:SwipeCell
        },
        mounted() {
            this.loadDataDefault();
        },
        methods: {
            manuonChange(picker, obj, index) { //下拉滑动事件
                this.manuselectIndex = index;
            },
            _manupopupInput() { //input键入事件
                var InputValue = event.target.value;
                if (this.outTime == 0) {
                    this.outTime = setTimeout(() => {
                        this.LoadDataByErrorContentClick(InputValue);
                    }, 1500)
                } else {
                    clearTimeout(this.outTime)
                    this.outTime = setTimeout(() => {
                        this.LoadDataByErrorContentClick(InputValue);
                    }, 1500)
                }
            },
            manuconfirm() { //选择框选中事件
                var data = (this.manudata[this.manuselectIndex]).toString();
                this.ErrorData.SBMC = data.substring(0, data.indexOf("("));
                this.ErrorData.SBBH = data.substring(data.indexOf("(") + 1, data.indexOf(")"));
                this.showDiaLog = false;
            },
            onConfirm(date) {//  日历
                const _Date =
                    `${date.getFullYear()}-${date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1}-${date.getDate() < 9 ? '0' + date.getDate() : date.getDate()}`
                this.setData.explain = _Date
                this.showCalendar = false
            },
            upload() { //页面提交
                let data = [];
                this.list.map(x => {
                    data.push({
                        XMBH: x.XMBH,
                        JCJG: !!x.JCJG ? x.JCJG : x.BZ.split('/')[0]
                    });
                })
                this.$post('api/QualityControl/XJSSTJ', {
                    Model: {
                        JCRXM: this.$UserInfo.UserName,
                        SSR: this.$UserInfo.UserId,
                        SSRQ: this.NowDate,
                        JHDH: this.data.JHDH,
                        KSBH: this.data.KSBH,
                        SSKS: this.$UserInfo.DepartmentId,
                        LRR: this.$UserInfo.UserId,
                        LRRQ: this.NowDate,
                        STORE: this.$UserInfo.StoreCode,
                        YSBZ: 'N',
                        SSDH: this.data.SSDH,
                        Abnormal:JSON.stringify(this.ErrorResult)
                    },
                    Deteail: data,
                    STORE: this.$UserInfo.StoreCode,
                    GKHM: this.$UserInfo.GKHM
                }).then(result => {
                    if (result.Status) {
                        if (!this.uploadImg.length > 0) {
                            this.$Toast('提交成功!');
                            setTimeout(x => {
                                this.$router.back();
                            }, 2000);
                            return
                        }
                        this.$Toast('保存巡检记录成功,正在上传图片信息!');
                        setTimeout(x => {
                            this.UploadSave(result.Msg);
                        }, 2000);
                    } else this.$Toast('保存失败,请联系管理员!');
                })
            },
            loadDataDefault() {
                if (this.data.SSDH) {
                    this.$get('api/QualityControl/XJYSDetail', { //查询记录
                        KSBH: this.data.KSBH,
                        JHDH: this.data.JHDH,
                        SSDH: this.data.SSDH
                    }).then(result => {
                        try{
                            this.ErrorResult=JSON.parse(result.WHLSList[0].Abnormal);
                            this.list = result.PojectList;
                            this.GetUpImg();
                        }catch(e){
                            this.$Toast('数据异常，请联系管理员!');
                        }
                    })
                } else {
                    this.$get('api/QualityControl/CheckProjectAndAccessory', { //查询模板
                        KSBH: this.data.KSBH,
                        JHDH: this.data.JHDH,
                        SSDH: '',
                    }).then(result => {
                        result.Projects.map(x => {
                            this.list.push({
                                BZ: x.BZ,
                                MC: x.MC,
                                JCJG: String.trim(x.JCJG),
                                XMBH: x.BH
                            });
                        })
                    })
                }
            },
            afterRead(obj) { //上传图片
                if (obj instanceof Array) {
                    let that = this;
                    obj.forEach(function(item, index) {
                        that.uploadImg.push(item);
                    })
                } else this.uploadImg.push(obj);
            },
            deleteImg(obj) { //删除图片
                if (obj.DABH) { //需要请求
                    this.$Dialog.confirm({
                        message: '确定删除?'
                    }).then(() => {
                        this.$get('api/QualityControl/DeleteAccessory', {
                            JHDH: obj.JHDH,
                            DABH: obj.DABH,
                            DAMC: obj.DAMC,
                            DALJ: obj.DALJ
                        }).then(result => {
                            this.uploadImg.splice(this.uploadImg.findIndex(x => x.random === obj.random),
                                1);
                            this.$Toast("删除成功!");
                        })
                    }).catch(() => {})
                } else { //直接删除
                    this.uploadImg.splice(this.uploadImg.findIndex(x => x.random === obj.random), 1);
                    this.$Bus.$emit('YSRKDelete', this.uploadImg);
                }
            },
            UploadSave(SSDH) { //巡检图片上传
                let ImgArray = [];
                this.uploadImg.map(x => {
                    !!x.content ? ImgArray.push(x.content) : '';
                })
                this.$post('api/QualityControl/PollingAccessoryUpload', {
                    JHDH: this.data.JHDH,
                    SSDH: SSDH,
                    GKHM: this.$UserInfo.UserId,
                    BaseList: ImgArray
                }).then(result => {
                    if (result.Status) {
                        this.$Toast(result.Msg);
                        setTimeout(x => {
                            this.$router.back();
                        }, 2000);
                    } else {
                        this.$Toast(result.Msg);
                    }
                })
            },
            GetUpImg() { //获取实施附件
                this.$get('api/QualityControl/GetUpImg', {
                    JHDH: this.data.JHDH,
                    SSDH: this.data.SSDH
                }).then(result => {
                    let that = this;
                    result.forEach(function(item, index) {
                        that.uploadImg.push({
                            DABH: item._imagebh,
                            JHDH: item._jhdh,
                            SSDH: item._ssdh,
                            url: item._repath,
                            random: that.$getRandomNumber(5),
                            DALJ: item._imagelj,
                            DAMC: item._imagemc
                        });
                    })
                })
            },
            ErrorButtonClick() { //新增异常情况
                if(this.ErrorData.SBMC=="请选择"){
                    this.$Toast("请选择资产，资产名称不能为空!");
                    return false
                }
                if(!this.ErrorData.YCQK){
                    this.$Toast("请输入异常情况，异常情况不能为空!");
                    return false
                }
                let Index=this.ErrorResult.findIndex(x=>x.SBBH===this.ErrorData.SBBH);
                if(Index!==-1){
                    this.$Toast(`您已添加过[${this.ErrorData.SBMC}]的异常情况,请勿重复添加!`);
                    return false;
                }
                this.ErrorResult.push(this.ErrorData);
                this.AddErrorContent=false;
                this.ErrorData={
                    SBMC:'请选择'
                };
            },
            EquipmentContentClick() { //查询科室下的设备
                this.LoadDataByErrorContentClick();
            },
            LoadDataByErrorContentClick(inputValue) {
                this.$post('api/DropDownList/AssetsList', {
                    GKHM: this.$UserInfo.UserId,
                    Store: this.$UserInfo.StoreCode,
                    QueryStr: inputValue ? inputValue : '',
                    SYKS: this.data.KSBH
                }).then(result => {
                    this.manuselectIndex=0;
                    this.manudata = [];
                    for (let i = 0; i < result.AssetsList.length; i++) {
                        this.manudata.push(`${result.AssetsList[i].b}(${result.AssetsList[i].a})`);
                    }
                    this.showDiaLog = true
                })
            },_deleteErrorContent(index){//删除ErrorContent
                this.ErrorResult.splice(index,1);
            }
        },
    }
</script>

<style scoped lang="scss">
    .QualityTest {
        /*transform: rotate(90deg);*/
        /*width: 100vh;*/
        /*min-height: 750px;*/
        background: #F0F4F7;
        /*transform-origin: left top;*/
        /*margin-left: 100%;*/
        padding-bottom: 20px;
        padding-top: 48px;

        &>div {
            &:nth-child(3) {
                width: 95%;
                margin: 0 auto;
                &>span{
                    font-size: 3.533vw;

                    &:first-child{
                        color:#14171a;
                    }

                    &:last-child{
                        float:right;
                        font-weight: bold;
                        color:#4fa69e
                    }
                }
            }
        }
    }

    .QualityTestHeader {
        width: 100vw;
        height: 48px;
        text-align: center;
        line-height: 48px;
        position: fixed;
        font-size: 18px;
        color: #fff;
        background: $THEME-COLOR;
        top: 0;
        z-index: 10;

        img {
            width: 23px;
            position: absolute;
            left: 2px;
            top: 2px;
            padding: 10px
        }
    }

    .infoBox {
        width: 96%;
        margin: 10px auto;
        padding: 10px 20px;

        .title {
            font-size: 12px;
            margin-bottom: 7px;
        }
    }

    .info {
        display: flex;

        &>div {
            flex: 1;
            text-align: left;
            font-size: 12px;
            color: #999;

            &:first-child {
                flex: 0.35
            }

            p {
                margin-top: 5px;
                margin-bottom: 9px;
                width: 95%;
            }

            span {
                color: $TEXT-DARK-COLOR;
            }

            img {
                width: 50px;
                height: 60px;
                border-radius: 1px;
            }
        }
    }

    .quality {
        padding: 0;
    }

    .tableTitle {
        display: flex;
        height: 33px;
        line-height: 33px;
        border-bottom: 1px solid #e8e8e8;
        font-weight: bold;

        div {
            flex: 1;
            font-size: 12px;
            color: $TEXT-DARK-COLOR;

            &:first-child {
                text-indent: 25%;
            }

            &:last-child {
                text-indent: 50%;
            }
        }
    }

    .tableItems {
        display: flex;
        font-size: 12px;
        color: #333;
        font-weight: bold;

        .tableItemsLeftBox {
            width: 100px;
            border-right: 1px solid #e8e8e8;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid #e8e8e8;
        }

        &:last-child .tableItemsLeftBox,
        &:last-child .tableItemsRightBox>div,
        &:last-child .tableItemsRightBox2 {
            border-bottom: none;
        }

        .tableItemsRightBox {
            flex: 1;

            &>div {
                display: flex;
                border-bottom: 1px solid #e8e8e8;

                &>div {
                    &:first-child {
                        width: 280px;
                        padding: 19px 21px 12px;
                        text-align: left;
                    }

                    &:nth-child(2) {
                        flex: 0.8;
                        align-items: center;
                        justify-content: center;
                        display: flex;

                        div {
                            width: 80px;
                            height: 25px;
                            background: #F3F3F3;
                            border-radius: 2px;
                            color: #858585;
                            font-size: 8px;
                            line-height: 25px;
                            text-align: center;
                            font-weight: 400;
                            margin-right: 14px;

                            &:last-child {
                                margin-right: 0;
                            }
                        }

                        .action {
                            background: $THEME-COLOR;
                            color: #fff;
                            border-color: rgba(0, 0, 0, 0);
                        }
                    }

                    &:last-child {
                        flex: 1;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        input {
                            width: 115px;
                            height: 25px;
                            background: #f3f3f3;
                            border-radius: 4px;
                            font-size: 10px;
                            font-weight: 400;
                            text-indent: 12px;

                            ::-webkit-input-placeholder {
                                color: #858585;
                            }
                        }
                    }
                }
            }
        }

        .tableItemsRightBox2 {
            flex: 1;
            padding: 10px;
            border-bottom: 1px solid #e8e8e8;

            &>input {
                width: 95%;
                border: 1px solid #e8e8e8;
                margin: auto;
                border-radius: 4px;
                height: 40px;
                background: #f3f3f3;
                font-size: 10px;
                text-indent: 10px;
                font-weight: 400;
            }
        }

        .checkbox-group {
            padding-bottom: 0;

            &>div {
                display: flex;
                flex-wrap: wrap;

                &>div {
                    margin-right: 25px;
                    margin-bottom: 10px;
                }
            }
        }

        .checkbox {
            &>div {
                display: flex;

                &>div {
                    margin-right: 20px;
                }
            }
        }

        .input-group {
            display: flex;

            &>div {
                flex: 1;
                text-align: center;

                input,
                .calenderText {
                    width: 80%;
                    text-align: center;
                    border: 1px solid #e8e8e8;
                    margin: auto;
                    margin-top: 10px;
                    border-radius: 4px;
                    height: 25px;
                    background: #f3f3f3;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 25px;
                    padding: 0;

                    ::-webkit-input-placeholder {
                        color: #858585;
                    }

                    &:disabled {
                        background-color: #f3f3f3;
                        color: $TEXT-DARK-COLOR;
                        opacity: 1;
                    }
                }
            }
        }
    }

    .lastBox {
        padding: 0 10px;

        span {
            color: #F4F4F4 !important;
        }
    }

    .imgBox {
        width: 96%;
        margin: auto;
    }

    .footer {
        width: 96%;
        margin: auto;
        height: 40px;
        background: $THEME-COLOR;
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        line-height: 40px;
        text-align: center;
    }

    .marginTop {
        margin-top: 300px;
    }

    .ErrorContent {
        .EquipmentContent {
            width: 100%;
            font-size: 3.33vw;

            span {
                color: #646566;
                padding-left: 2.5%;
            }

            div {
                display: inline-block;
                width: 82%;
                text-align: right;

                img {
                    height: 3.667vw;
                    width: 3.667vw;
                }
            }
        }

        .ErrorButton {
            height: 40px;
            background: #4FA69E;
            color: #FFFFFF;
            text-align: center;
            width: 100%;
            position: absolute;
            bottom: 0;

            span {
                position: fixed;
                bottom: 10px;
            }
        }

    }

    .picker-header {
        height: 10.2vw;
        span {
            font-size: 3.533vw;
        }

        input {
            height: 4.5vw;
            margin-top: 2.5vw;
        }
    }
    .emptyContent{
        color: #d2cfcf;
    }
    .AccessoriesItemBox{
        margin: 10px 0;
        .delete{
            width: 64px;
            height: 64px;
            background: #F25643;
            border-radius: 50%;
            text-align: center;
            margin-top: 30px;
            img{
                width: 40px;
                margin-top: 12px;
            }
        }

    }
    .van-swipe-cell__right{
        background: #FFFFFF !important;
    }
    .van-cell>>>.labelclass{
        font-size: 3.33vw;
    }
    .van-cell>>>.van-field__control--right{
        font-size: 3vw !important;
    }
</style>



// WEBPACK FOOTER //
// src/page/pollingimplementDefault_XS/pollingimplementDefault_XS.vue